// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --input-container-input-height: auto;
  display: flex;
}
:host ::ng-deep mat-chip-grid {
  --mat-chip-container-height: 24px;
  --mat-chip-container-shape-radius: 12px;
  --mat-chip-label-text-size: 12px;
  --mat-chip-trailing-action-state-layer-color: transparent;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
:host ::ng-deep mat-chip-row .mat-mdc-standard-chip, :host ::ng-deep mat-chip-row.mat-mdc-standard-chip {
  height: 24px;
}
:host ::ng-deep mat-chip-row .mat-mdc-chip-action-label {
  padding: 0 4px;
}
:host ::ng-deep mat-chip-row .mat-mdc-chip-remove,
:host ::ng-deep mat-chip-row .remove-icon {
  padding: 0 6px 0 0 !important;
  font-size: 16px;
  line-height: 1;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep mat-chip-row .mat-mdc-chip-remove span,
:host ::ng-deep mat-chip-row .remove-icon span {
  display: inline-block;
  line-height: 1;
  position: relative;
  top: 1px;
}
:host ::ng-deep mat-chip-row .mat-mdc-chip-remove::before, :host ::ng-deep mat-chip-row .mat-mdc-chip-remove::after,
:host ::ng-deep mat-chip-row .remove-icon::before,
:host ::ng-deep mat-chip-row .remove-icon::after {
  display: none !important;
}
:host .fields-container {
  flex: auto;
  display: flex;
  flex-direction: column;
}
:host .input-container {
  position: relative;
  margin-top: 10px;
}
:host .input-container input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
  margin: 0;
  height: var(--input-container-input-height);
}
:host .input-container .input-search-placeholder {
  position: absolute;
  opacity: 0.6;
  pointer-events: none;
  left: 15px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
